/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget useful link init translation
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { IWidgetUsefulLinksTranslation } from '../../../types/pages/dashboard/widgetUsefulLinks';

const initTranslationWidgetUsefulLinks: IWidgetUsefulLinksTranslation = {
    links: {
        block: '',
        document: '',
        limit: '',
        reconciliation: '',
    },
    title: '',
};

export default initTranslationWidgetUsefulLinks;
